"use client";

import {
  Button as NextUIButton,
  ButtonProps as NextUIButtonProps,
} from "@nextui-org/react";
import { extendVariants } from "@nextui-org/system";

export type ButtonProps = Omit<
  NextUIButtonProps,
  "color" | "size" | "radius"
> & {
  color?: "white" | "gray" | "red";
  size?: "xs" | "sm" | "md" | "xl";
  radius?: "none" | "sm" | "md" | "lg";
};

export const Button = extendVariants(
  NextUIButton,
  {
    variants: {
      // <- modify/add variants
      color: {
        white:
          "text-dark bg-white transition-colors duration-200 hover:bg-gray-100 active:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none",
        gray: "text-gray-1210 disabled:opacity-50 disabled:pointer-events-none",
        red: "text-white bg-red disabled:opacity-50 disabled:pointer-events-none",
      },
      variant: {
        bordered: "border border-solid",
      },
      isDisabled: {
        true: "opacity-50 cursor-not-allowed",
      },
      size: {
        xs: "px-4 h-[4.4rem] text-sm",
        sm: "px-4 h-[4.8rem] text-md",
        md: "px-4 h-[5.4rem] text-md",
        xl: "px-4 h-[6.4rem] text-lg",
      },
      radius: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md",
        lg: "rounded-lg",
      },
    },
    defaultVariants: {
      // <- modify/add default variants
      color: "white",
      variant: "bordered",
      size: "md",
      radius: "sm",
    },
    compoundVariants: [
      // <- modify/add compound variants
      {
        class: "gap-4 ![&>svg]:max-w-12",
      },
      {
        color: "white",
        variant: "bordered",
        class: "border-gray-100",
      },
      {
        color: "gray",
        variant: "bordered",
        class: "border-gray-1210",
      },
    ],
  },
  {
    twMerge: true, // <- enable twMerge for className merging
  },
);

export default Button;
